<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-9">
<h2 class="fmatter">ACKNOWLEDGEMENTS</h2>
<p class="noindent"><span class="dropcap">I</span> would like to thank Pen and Sword for their support with this second edition, especially Amy Jordan, Simon Fowler, Rupert Harding, and to Gaynor Haliday for her careful proof-reading.</p>
</a><a id="VPS-10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Acknowledgements.vue?88cc7d7e